import React, { useState } from "react";
import AppliMobileForm from '../components/AppliMobileForm'
import '../styles/CGU.css';
const MobileAppRequestForm = () => {
    const [reason, setReason] = useState("");
    const [formData, setFormData] = useState({
        nom: '',
        email: '',
        telephone: '',
        message: ''
    });
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        alert(`Merci pour votre retour ! Raison : ${reason}`);
        setReason("");
        setFormData({
            nom: '',
            email: '',
            telephone: '',
            message: ''
        });
    };

    return (
        <div className="cgu-page">
            <div className="message-scuse">
                <h1>Ayi Sabari</h1>
                <h2>Nous demandons pardon</h2>
                <p>
                    On sait, on sait… Vous voulez l’appli mobile, et nous aussi !</p>
                <p>Mais nos développeurs sont actuellement en mode ninja 🥷, codant jour et nuit (avec un peu trop de café ☕).</p>
                <>En attendant, dites-nous pourquoi vous voulez télécharger l’appli, ça pourrait les motiver à aller encore plus vite ! 🚀</>

            </div>

            <h2 className="text-xl font-bold mb-4">Pourquoi voulez-vous l'appli mobile ? 📱</h2>
            <p className="text-gray-700 mb-4">
                Dites-nous ce qui vous motive, on transmettra aux développeurs en train de coder sous caféine ! ☕💻
            </p>
            <p>Surtout enregistrez vous à la liste d'attente... </p>
            <AppliMobileForm />
        </div>
    );
};

export default MobileAppRequestForm;
